export enum TaxCode {
  ZERO_RATED = "ZeroRated",
  VAT = "VAT",
}
